export default "__VITE_ASSET__6a8fcd38__"